import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

import withAuthorization from 'components/withAuthorization/withAuthorization';
// material-ui components
import withStyles from "material-ui/styles/withStyles";
// @material-ui/icons
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import SectionContent from "./Sections/SectionContent";
import GridItemHome from "components/Grid/GridItemHome.jsx";

import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";


class ProjectPage extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
        <Parallax image={require("assets/img/bg10.jpg")}>
          <div className={classes.container}>
            <GridContainer>
              <GridItemHome xs={12} sm={12} md={6}>
                <div className={classes.brand}>
                  <h1 className={classes.title}>Project SEA</h1>
                  <h3 className={classes.subtitle}>
                    Entrepreneurs and digital nomads living and working completely chore free in paradise.
                  </h3>
                  <br/>
                  <h5 className={classes.subtitleparagraph}>
                  <strong>Reinvent work with a focus on remote work setups.</strong>
                  </h5>
                </div>
              </GridItemHome>
              <GridItemHome xs={12} sm={12} md={6}>
                  
                </GridItemHome>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
            <SectionContent />
        </div>
        <Footer />
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)((withStyles(componentsStyle)(ProjectPage)));



// WEBPACK FOOTER //
// ./src/views/ProjectPage/ProjectPage.jsx